import { MoneyListTypeDict } from "../dictionaries/statusEnum";

export function removeNthEl(arr, i) {
  return [...arr.slice(0, i), ...arr.slice(i + 1)];
}

export function saveFile(blobArray, filename) {
  const selectedFile = blobArray.find((x) => x.name == filename);
  const blob = new Blob([selectedFile]);

  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    const a = document.createElement("a");
    a.target = "_blank";
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  }
}

export const renderArray = (array) => array.join(", ");

export const castBool2Word = (object, booleanKyepixValues) => {
  const foundItem = booleanKyepixValues.find((x) => x.name === object.name);
  if (!foundItem) {
    return object;
  }
  return {
    name: object.name,
    value: foundItem[object.value],
    refValue: object.refValue,
  };
};

export const reformatDataForTable = (
  fetchedData,
  key2PropertyLabelObject,
  booleanDictionaryValues = [],
) => {
  return Object.keys(fetchedData)
    .sort((a, b) => {
      return (
        Object.keys(key2PropertyLabelObject).indexOf(a) -
        Object.keys(key2PropertyLabelObject).indexOf(b)
      );
    })
    .map((key) => {
      return castBool2Word(
        {
          name: key2PropertyLabelObject[key],
          value: Array.isArray(fetchedData[key])
            ? (fetchedData[key] = renderArray(fetchedData[key]))
            : fetchedData[key],
          refValue: key,
        },
        booleanDictionaryValues,
      );
    })
    .filter((a) => a.name); // filter: eliminate not truthy values
};

export const transformDatagridColumnsDataToDetailsData = (columns) => {
  const _arr = columns.map((column) => {
    return {
      [column.field]: column.headerName,
    };
  });

  return Object.assign({}, ..._arr);
};

export const transformDetailsValuesToShowUI = (values) => {
  if (values?.money_list_type === "chamber") {
    values.money_list_type = MoneyListTypeDict.Chamber;
  }
  if (values?.money_list_type === "gemi") {
    values.money_list_type = MoneyListTypeDict.Gemi;
  }
  return values;
};

export const isSubmitEnabled = (formik) => {
  const { errors, dirty: touched } = formik;
  let disabledButton = false;
  const errors_bool = !!Object.keys(errors).length;
  if (errors_bool) {
    disabledButton = true;
  } else {
    if (touched) {
      disabledButton = false;
    } else {
      disabledButton = true;
    }
  }
  return disabledButton;
};

export const downloadExcel = (response, name_of_excel) => {
  const blob = new Blob([response.data], {
    type: response.headers["content-type"],
  });
  const csvURL = window.URL.createObjectURL(blob);
  const tempLink = document.createElement("a");
  tempLink.href = csvURL;
  tempLink.setAttribute("download", `${name_of_excel}.xlsx`);
  tempLink.click();
};

/** usually we use this function to send only the fields that actually have a value
 * {
 *    name: '',
 *    value: 'test
 * }
 *
 *   =====>
 *
 * {
 *  value: 'test'
 * }
 */
export const eliminateOjectNotTruthyValues = (object) => {
  const _arr = Object.keys(object)
    .map((key) => {
      if (Array.isArray(object[key])) {
        if (object[key].length > 0) {
          return {
            [key]: object[key].reduce((x, y) => `${x},${y}`),
          };
        }
      } else if (
        object[key] !== null &&
        object[key] !== undefined &&
        object[key] !== "" &&
        object[key] !== "all"
      ) {
        return {
          [key]: object[key],
        };
      }
    })
    .filter((a) => a); // filter: eliminate not truthy values
  return Object.assign({}, ..._arr);
};

export const createFilterModel = (filters) => {
  const _filters = Object.keys(filters).map((filter) => {
    return {
      [filter]: filters[filter],
    };
  });
  return Object.assign({}, ..._filters);
};

export const createOrderModel = (sortModel) => {
  return sortModel.length > 0
    ? { order: [sortModel[0].field, sortModel[0].sort] }
    : [];
};

export const createPaginationModel = (page, pageSize) => {
  return {
    page: page,
    page_length: pageSize,
  };
};

export const convertFitlersToQueryParams = (filters) => {
  const queryParams = [];
  Object.keys(filters).forEach((key) => {
    if (filters[key]) {
      queryParams.push(`${key}=${filters[key]}`);
    }
  });
  console.log(queryParams.join("&"));
  return queryParams.join("&");
};
